import { Badge, Button, Flash, Modal, Table, TableSelection, Tooltip } from 'AWS-UI-Components-React';
import React from 'react';
import { ToolTipWithMarginStyle } from '../../styles/common_styles';
import { zip } from '../../utilities';
import { getJSClient } from '../js_client';
import { Badges, Change, KeyOriginalMapping } from './mapper';
import { getBenchmarkConfigDiffView, prepareListItem } from './utils';

export class MappingReview extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      data: {},
      dataLoaded: false,
      componentRows: [],
      subComponentRows: [],
      componentSelectedMappings: [],
      subComponentSelectedMappings: [],
      selected: false,
      componentMappingColumnDefinitions: [],
      subComponentMappingColumnDefinitions: [],
      mappingPullFailed: false,
      failureMessage: "",
    };
    this.cognosAccountMap = {};
    this.excludedCognosAccounts = {};
    for (let cognos of props.cognosConfig) {
      this.cognosAccountMap[cognos.id] = {
        label: cognos.label,
        excluded: cognos.excluded || false,
        comment: cognos.comment || 'No comment',
      };
    }
  }

  componentWillMount = () => {
    this.client = getJSClient();
    this.getMappings();
  };

  getMappings = () => {
    let filters = { version: "SA-" + this.props.stagingArea };
    this.client.getMappings(this.onMappingPullSuccess, this.onMappingPullFailure, filters);
  };

  onMappingPullFailure = (response) => {
    console.error(response);
    this.setState({ mappingPullFailed: true, failureMessage: response })
  };

  sameKey = (a, b) => {
    return a.marketplace === b.marketplace && a.channel === b.channel && a.component === b.component && a.subComponent === b.subComponent;
  };

  onMappingPullSuccess = (response) => {
    let stagedMappings = response.mappings;
    if (Array.isArray(stagedMappings)) {
      stagedMappings.sort(this.compare);
    } else {
      let array = [];
      for (let key in stagedMappings) {
        array.push(stagedMappings[key]);
      }
      array.sort(this.compare);
      stagedMappings = array;
    }
    let subComponentMappings = [];
    let componentMappings = [];
    let subComponentIndex = 1;
    let componentIndex = 1;
    for (let mapping of stagedMappings) {
      mapping.cognosBenchmark = mapping.cognosBenchmark || [];
      mapping.accuracyBenchmark = mapping.accuracyBenchmark || [];
      mapping.cpValueMap = mapping.cpValueMap || [];
      if (mapping.subComponent && mapping.component !== mapping.subComponent) {
        mapping.index = subComponentIndex++;
        subComponentMappings.push(mapping);
      } else {
        mapping.index = componentIndex++;
        componentMappings.push(mapping);
      }
    }
    subComponentMappings.forEach(this.flatten);
    componentMappings.forEach(this.flatten);

    this.keys = [
      "subComponent", "cpValueMap", "accuracyBenchmark", "cognosBenchmark", 'baseFactor', 'reallocationGrain', 'subcomponentRollup', 'comment'
    ];

    this.headings = ["SubComponent", "Flashback Columns", "Accuracy Benchmark", "P&L Benchmark", 'HCP Driver', 'Reallocation Grain', 'Rollup Enabled', 'Comment'];
    this.componentHeadings = ["Component", "CP Column", "Accuracy Benchmark", "P&L Benchmark", 'HCP Driver', 'Reallocation Grain','Subcomponent Rollup Enabled', 'Comment'];

    this.setState({subComponentMappingColumnDefinitions: this.generateColumns(this.headings)});
    this.setState({componentMappingColumnDefinitions: this.generateColumns(this.componentHeadings)});

    let subComponentRows = [];
    let componentRows = [];
    for (let map of subComponentMappings) {
      subComponentRows.push(this.buildRow(map, this.state.subComponentMappingColumnDefinitions));
    }

    for (let map of componentMappings) {
      componentRows.push(this.buildRow(map, this.state.componentMappingColumnDefinitions));
    }

    this.setState({
      subComponentRows: subComponentRows,
      componentRows: componentRows,
      subComponentSelectedMappings: subComponentMappings,
      componentSelectedMappings: componentMappings,
      selected: subComponentMappings.length || componentMappings.length,
      dataLoaded: true
    });
  };

  flatten = (item) => {
    if (!item['subComponent']) {
      item['subComponent'] = item['component'];
    }
    if (item['latest'] && !item[latest]['subComponent']) {
      item['latest']['subComponent'] = item['latest']['component'];
    }
    let data = this.state.data;
    data[item['subComponent']] = item;
    this.setState({ data: data });
  };

  generateColumns = (headings) => {
    let columns = [];
    for (let [key, heading] of zip(this.keys, headings)) {
      let columnEntry = {};
      columnEntry['id'] = key;
      columnEntry['header'] = () => heading;
      columnEntry['cell'] = (item) => {
        let subComponentObj = this.state.data[item['subComponent']];
        if (!subComponentObj) return 'New Item';
        if (key === 'cpValueMap') {
          return this.getColumnDiffView(subComponentObj, item, key, true);
        } else if (key === 'cognosBenchmark') {
          return this.getColumnDiffView(subComponentObj, item, key, true);
        } else if (key === 'accuracyBenchmark') {
          return this.getColumnDiffView(subComponentObj, item, key, false);
        } else if (key === 'subComponent') {
          let output = item[key];
          if (subComponentObj.change) {
            output = Badges[subComponentObj.change](output);
          }
          if (this.state.data[item.subComponent]['channel']) {
            output = <span>
                       <b>
                         Channel: {this.state.data[item.subComponent]['channel']}
                       </b>
                       <br/>
                       {output}
                     </span>;
          }
          if (this.state.data[item.subComponent]['marketplace']) {
            output = <span>
                       <b>
                         Marketplace: {this.state.data[item.subComponent]['marketplace']}
                       </b>
                       <br/>
                       {output}
                     </span>;
          }
          let versionConflict = this.props.versionConflicts.some((vc) => {
            return this.sameKey(vc, subComponentObj)
          });
          if (versionConflict) {
            output = <span>
                       <Badge color="red" content="VERSION CONFLICT"/>
                       {'  '}{output}
                     </span>
          }
          return output;
        } else if (key === 'baseFactor'){
          return getBenchmarkConfigDiffView(subComponentObj, item, key);
        } else if (key === 'reallocationGrain'){
          return getBenchmarkConfigDiffView(subComponentObj, item, key);
        } else if (key === 'subcomponentRollup'){
          return getBenchmarkConfigDiffView(subComponentObj, item, key);
        } else if (key === 'comment') {
          return getBenchmarkConfigDiffView(subComponentObj, item, key);
        }
        return item[key];
      };
      columnEntry['minWidth'] = '100px';
      columnEntry['allowLineWrap'] = false;
      columns.push(columnEntry);
    }
    return columns;
  };

  getColumnDiffView = (subComponentObj, item, key, hideType) => {
    let listItems = [];
    if (subComponentObj.change === Change.MODIFY) {
      let currMap = {};
      let prevMap = {};
      if (item[key]) {
        for (let elem of item[key]) {
          currMap[elem.type === "Cognos" ? elem.value : elem.type] = elem;
        }
      }
      if (subComponentObj[KeyOriginalMapping[key]]) {
        for (let elem of subComponentObj[KeyOriginalMapping[key]]) {
          prevMap[elem.type === "Cognos" ? elem.value : elem.type] = elem;
        }
        for (let prev of Object.keys(prevMap)) {
          if (prev in currMap) {
            let curr = currMap[prev];
            if (prevMap[prev].operation === currMap[prev].operation && prevMap[prev].type === currMap[prev].type && prevMap[prev].value === currMap[prev].value) {
              listItems.push(this.prepareListItem(prevMap[prev], hideType, "none"));
            } else {
              listItems.push(this.prepareListItem(currMap[prev], hideType, Change.MODIFY));
            }
            delete currMap[prev];
          } else {
            listItems.push(this.prepareListItem(prevMap[prev], hideType, Change.DELETE));
          }
        }
      }
      if (item[key]) {
        for (let curr of Object.keys(currMap)){
          listItems.push(this.prepareListItem(currMap[curr], hideType, Change.ADD));
        }
      }
    } else if (item[key]) {
      for (let i = 0; i < item[key].length; i++) {
        listItems.push(this.prepareListItem(item[key][i], hideType, subComponentObj.change === Change.DELETE ? "mappingDeleted" : "none"));
      }
    }
    return this.getList(listItems);
  };

  prepareListItem = (map, hideType, change) => {
    return prepareListItem(map, hideType, change, this.cognosAccountMap, Badges);
  };

  getList(listItems) {
    return (
      <div>
        <ul className={'non-decorated-ul'}>{listItems}</ul>
      </div>
    );
  }

  buildRow = (row, columnDefinitions) => {
    let rowObj = {};
    for (let column of columnDefinitions) {
      if (row[column.id]) {
        rowObj[column.id] = row[column.id];
      }
    }
    rowObj.component = row.component;
    return rowObj;
  };

  componentSelectionChanged = (data) => {
    let items = data.detail.selectedItems;
    let mappings = [];
    for (let i = 0; i < items.length; i++) {
      mappings.push(this.state.data[items[i].subComponent])
    }
    this.setState({ componentSelectedMappings: mappings, selected: mappings.length > 0 || this.state.subComponentSelectedMappings.length > 0 });
  };

  subComponentSelectionChanged = (data) => {
    let items = data.detail.selectedItems;
    let mappings = [];
    for (let i = 0; i < items.length; i++) {
      mappings.push(this.state.data[items[i].subComponent])
    }
    this.setState({ subComponentSelectedMappings: mappings, selected: mappings.length > 0 || this.state.componentSelectedMappings.length > 0 });
  };

  onUnstage = () => {
    this.props.resetReviewFlash();
    this.props.unstageChanges(this.state.componentSelectedMappings.concat(this.state.subComponentSelectedMappings));
    this.setState({ componentSelectedMappings: [], subComponentSelectedMappings: [], selected: false });
  };

  onPublish = () => {
    this.props.resetReviewFlash();
    this.props.publishChanges(this.state.componentSelectedMappings.concat(this.state.subComponentSelectedMappings));
    this.setState({ componentSelectedMappings: [], subComponentSelectedMappings: [], selected: false });
  };

  onClose = () => {
    this.props.resetReviewFlash();
    this.props.onClose();
  };

  displayFlash = () => {
    return (
      <div>
        { this.state.mappingPullFailed && (
          <Flash
            type="error"
            content={'Failed to pull mappings: ' + this.state.failureMessage}
            dismissible={true}
            onDismiss={this.flashDismissed}
          />
        )}
        {this.props.unstageInProgress && (
          <Flash
            loading={true}
            content="Reverting changes"
            dismissible={false}
          />
        )}
        {this.props.unstageSucceeded && (
          <Flash
            type="success"
            content="Revert completed"
            dismissible={true}
            onDismiss={this.props.resetReviewFlash}
          />
        )}
        {this.props.unstageFailed && (
          <Flash
            type="error"
            content={'Revert failed: ' + this.props.reviewFailureMessage}
            dismissible={true}
            onDismiss={this.props.resetReviewFlash}
          />
        )}
        {this.props.publishInProgress && (
          <Flash
            loading={true}
            content={"Publishing changes"}
            dismissible={false}
          />
        )}
        {(this.props.publishSucceeded && !this.props.versionConflicts.length) && (
          <Flash
            type="success"
            content="Publish completed"
            dismissible={true}
            onDismiss={this.props.resetReviewFlash}
          />
        )}
        {this.props.publishFailed && (
          <Flash
            type="error"
            content={'Publish failed: ' + this.props.reviewFailureMessage}
            dismissible={true}
            onDismiss={this.props.resetReviewFlash}
          />
        )}
        {this.props.versionConflicts.length > 0 && (
          <Flash
            type="error"
            content="VERSION CONFLICT: One or more of the mappings you attempted to change have been modified by another user.
              To publish, un-stage the affected changes and (optionally) re-stage them."
            dismissible={false}
          />
        )}
        <br/>
      </div>
    );
  };

  flashDismissed = () => {
    this.setState({ mappingPullFailed: false });
  };

  render() {
    const { unstageInProgress, unstageSucceeded, unstageFailed, publishInProgress, publishSucceeded, publishFailed } = this.props;
    return (
      <div>
        { (this.state.dataLoaded || unstageSucceeded || unstageFailed || publishSucceeded || publishFailed) &&
          <Modal visible={true}
            size="max"
            onDismiss={this.onClose}
            header={"Staged Change Review"}
            footer={
              <span className="awsui-util-f-r">
                <Button text="Close" onClick={this.onClose}/>
                <Tooltip className={ToolTipWithMarginStyle} text={this.state.selected ? "Clears selected changes" : "Select mappings to revert"} position="top">
                  <Button text="Revert Changes" loading={this.props.unstageInProgress} disabled={!this.state.selected || publishInProgress} onClick={this.onUnstage}/>
                </Tooltip>
                <Tooltip className={ToolTipWithMarginStyle} text={this.state.selected ? "Saves selected changes to official mappings" : "Select mappings to publish"} position="top">
                  <Button variant="primary" text="Publish Changes" loading={this.props.publishInProgress} disabled={!this.state.selected || unstageInProgress} onClick={this.onPublish}/>
                </Tooltip>
              </span>
            }
            content={
            <div>
              { this.displayFlash() }
              <Table columnDefinitions={this.state.componentMappingColumnDefinitions}
                items={this.state.componentRows}
                header={this.getComponentHeader()}
                empty={this.getEmptyTableUI()}>
                { this.state.componentRows.length !== 0 &&
                  <TableSelection selectedItems={this.state.componentSelectedMappings} onSelectionChange={this.componentSelectionChanged} trackBy="subComponent"/>
                }
              </Table>
              <br/>
              <Table columnDefinitions={this.state.subComponentMappingColumnDefinitions}
                items={this.state.subComponentRows}
                header={this.getHeader()}
                empty={this.getEmptyTableUI()}>
                { this.state.subComponentRows.length !== 0 &&
                  <TableSelection selectedItems={this.state.subComponentSelectedMappings} onSelectionChange={this.subComponentSelectionChanged} trackBy="subComponent"/>
                }
              </Table>
            </div>
            }
          />
        }
      </div>
    );
  }

  getEmptyTableUI() {
    const {error} = this.state;
    return <div className="awsui-util-t-c">
      <div>
        {error && <b>Error loading staged changes</b>}
      </div>
      {!error &&
        <div className="awsui-util-pt-s awsui-util-mb-xs">
          No staged changes found
        </div>
      }
    </div>;
  }

  getHeader() {
    const {subComponentRows} = this.state;
    return <div className="awsui-util-action-stripe">
      <div className="awsui-util-action-stripe-title">
        <h2>
          Sub Component Changes{' '}<span className="awsui-util-header-counter">({subComponentRows.length})</span>
        </h2>
      </div>
    </div>;
  }

  getComponentHeader() {
    const {componentRows} = this.state;
    return <div className="awsui-util-action-stripe">
      <div className="awsui-util-action-stripe-title">
        <h2>
          Component Changes{' '}<span className="awsui-util-header-counter">({componentRows.length})</span>
        </h2>
      </div>
    </div>;
  }
}

export default MappingReview;



// WEBPACK FOOTER //
// ./src/components/mapper/mapping_review.jsx